import { Money } from ".";
import { Currency } from "./iso4217/currencies";

export const DEFAULT_CURRENCY = Currency.USD;

export const DEFAULT_CURRENCY_FORMATTER = getCurrencyFormatter(
  DEFAULT_CURRENCY,
  "narrowSymbol",
  "en-US",
);

export function getCurrencyFormatter(
  currencyCode?: string | null,
  currencyDisplay: Intl.NumberFormatOptions["currencyDisplay"] = "narrowSymbol",
  locale?: string,
) {
  if (!currencyCode) {
    currencyCode = DEFAULT_CURRENCY;
  }
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    currencyDisplay,
  });
}

export function moneyFormat(
  money: Money,
  currencyDisplay?: Intl.NumberFormatOptions["currencyDisplay"],
  locale?: string,
) {
  return getCurrencyFormatter(money.currency, currencyDisplay, locale).format(
    money.amount,
  );
}
